<template>
  <footer class="border-t border-white/5 bg-[#060609] py-10">
    <div class="page-shell">
      <div class="grid gap-10 md:grid-cols-3">
        <div>
          <p class="text-sm font-semibold text-[#f1f1f3]">Beiyi Data</p>
          <p class="mt-2 text-xs text-[#8b8b99]">武汉贝易科技有限公司</p>
        </div>

        <div>
          <p class="text-sm font-semibold text-[#f1f1f3]">{{ t(productsLabel) }}</p>
          <div class="mt-3 space-y-2">
            <a
              v-for="product in allProducts"
              :key="product.id"
              :href="product.links[0].url"
              target="_blank"
              rel="noopener noreferrer"
              class="block text-sm text-[#8b8b99] transition-colors duration-200 hover:text-white"
            >
              {{ t(product.name) }}
            </a>
          </div>
        </div>

        <div>
          <p class="text-sm font-semibold text-[#f1f1f3]">{{ t(contactLabel) }}</p>
          <a
            href="mailto:beibei@beiyidata.cn"
            target="_blank"
            rel="noopener noreferrer"
            class="mt-3 block text-sm text-[#8b8b99] transition-colors duration-200 hover:text-white"
          >
            beibei@beiyidata.cn
          </a>
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
            class="mt-2 block text-sm text-[#8b8b99] transition-colors duration-200 hover:text-white"
          >
            鄂ICP备2025119742
          </a>
        </div>
      </div>

      <p class="mt-8 text-center text-xs text-[#8b8b99]">{{ t(copyrightText) }}</p>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue'
import { categories } from '../data/products'
import { useI18n } from '../composables/useI18n'

const allProducts = computed(() => categories.flatMap((category) => category.products))
const { t } = useI18n()
const productsLabel = {
  zh: '产品',
  en: 'Products',
  es: 'Productos',
  fr: 'Produits',
  ja: '製品',
}
const contactLabel = {
  zh: '联系',
  en: 'Contact',
  es: 'Contacto',
  fr: 'Contact',
  ja: '連絡先',
}
const copyrightText = {
  zh: '© 2025 Beiyi Data. 保留所有权利。',
  en: '© 2025 Beiyi Data. All rights reserved.',
  es: '© 2025 Beiyi Data. Todos los derechos reservados.',
  fr: '© 2025 Beiyi Data. Tous droits réservés.',
  ja: '© 2025 Beiyi Data. All rights reserved.',
}
</script>
